import { createFileRoute, Outlet, redirect } from "@tanstack/react-router"

export const Route = createFileRoute("/app/resources/")({
  loader: () => {
    throw redirect({
      to: "/app/resources/resources",
      search: {
        availableCount: 1,
      },
    })
  },
  beforeLoad: ({ context: { t } }) => ({
    getTitle: () => t("Resources_Title"),
  }),
  component: Outlet,
})
